import { Button, Input, InputError } from '@foodsby/nutrient'
import currency from 'currency.js'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import { useStateValue } from '../../providers/ProviderCheckout'
import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'
import { Submitting } from '../common/Submitting'

export const AddCoupon = ({
  applyCoupon,
  error,
  isCheckoutCartLoading,
  isCouponApplying,
  setValue,
  value,
}) => {
  const [{ subscription }] = useStateValue()

  useEffect(() => {
    error && pushSnowplow(toOrderProcessSchema('daily', 'checkout_coupon_code_apply', null, error))
  }, [error])
  return (
    <div className="Input Input--attached">
      <label htmlFor="coupon">Coupon Code</label>
      <div className="Input--attachedSet ">
        <Input
          id="coupon"
          onBlur={evt =>
            pushSnowplow(
              toOrderProcessSchema('daily', 'checkout_coupon_code_enter', evt.target.value),
            )
          }
          onChange={evt => setValue(evt.target.value)}
          onKeyDown={e => {
            if (e.keyCode === 13) {
              applyCoupon(value.trim(), subscription.value)
              pushSnowplow(toOrderProcessSchema('daily', 'checkout_coupon_code_apply', value))
            }
          }}
          type="text"
          value={value}
        />
        {isCouponApplying ? (
          <Submitting text="Applying" />
        ) : (
          <Button
            className="secondary"
            disabled={!value || isCheckoutCartLoading}
            onClick={event => {
              event.preventDefault()
              applyCoupon(value.trim(), subscription.value)
              pushSnowplow(toOrderProcessSchema('daily', 'checkout_coupon_code_apply', value))
            }}
          >
            Apply
          </Button>
        )}
      </div>
      <InputError>{error}</InputError>
    </div>
  )
}
export const RemoveAppliedCoupon = ({
  applyCoupon,
  couponAmount,
  couponCode,
  error,
  isCouponApplying,
  setValue,
}) => {
  const [{ subscription }] = useStateValue()

  return (
    <div className="Input Input--attached">
      <label htmlFor="coupon">Coupon Applied</label>
      <div className="Input--attachedSet">
        <p className="Input-mockInput">
          {`${couponCode} `}({currency(couponAmount, { formatWithSymbol: true }).format()})
        </p>
        {error && (
          <div className="slide error">{error.response.data.message || error.response.data}</div>
        )}
        {isCouponApplying ? (
          <Submitting text="Changing" />
        ) : (
          <Button
            className="secondary"
            onClick={() => {
              applyCoupon('', subscription.value)
              setValue('')
            }}
            type="button"
          >
            Change
          </Button>
        )}
      </div>
    </div>
  )
}

export const Coupon = ({
  applyCoupon,
  couponAmount,
  couponApplied,
  couponCode,
  error,
  isCheckoutCartLoading,
  isCouponApplying,
}) => {
  const [value, setValue] = useState()

  return (
    <>
      {couponApplied ? (
        <RemoveAppliedCoupon
          applyCoupon={applyCoupon}
          couponAmount={couponAmount}
          couponCode={couponCode}
          error={error}
          isCheckoutCartLoading={isCheckoutCartLoading}
          isCouponApplying={isCouponApplying}
          setValue={setValue}
        />
      ) : (
        <AddCoupon
          applyCoupon={applyCoupon}
          error={error}
          isCheckoutCartLoading={isCheckoutCartLoading}
          isCouponApplying={isCouponApplying}
          setValue={setValue}
          value={value}
        />
      )}
    </>
  )
}

Coupon.propTypes = {
  applyCoupon: PropTypes.func,
  error: PropTypes.string,
  isCheckoutCartLoading: PropTypes.bool,
}

export default Coupon
